package app.smartcoding.realrate.domain.usecase

import app.smartcoding.realrate.domain.model.ErrorType
import app.smartcoding.realrate.domain.model.creditCardField.Loan

object LoanCalculator {
    fun receivedAmount(
        requestedAmount: Loan.RequestedAmount,
        taxRate: Loan.TaxRate
    ): Loan {
        if (requestedAmount.value < 0 || taxRate.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        val result = requestedAmount.value - (requestedAmount.value * taxRate.value / 100)
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.ReceivedAmount(result)
    }

    fun receivedAmount(
        requestedAmount: Loan.RequestedAmount,
        taxFee: Loan.TaxFee
    ): Loan {
        if (requestedAmount.value < 0 || taxFee.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        val result = requestedAmount.value - taxFee.value
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.ReceivedAmount(result)
    }

    fun requestedAmount(
        receivedAmount: Loan.ReceivedAmount,
        taxRate: Loan.TaxRate,
    ): Loan {
        if (receivedAmount.value < 0 || taxRate.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        val denominator = 1 - taxRate.value / 100
        if (denominator == 0.0) {
            return Loan.Error(ErrorType.DivisionByZero)
        }
        val result = receivedAmount.value / denominator
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.RequestedAmount(result)
    }

    fun taxFee(
        requestedAmount: Loan.RequestedAmount,
        taxRate: Loan.TaxRate,
    ): Loan {
        if (requestedAmount.value < 0 || taxRate.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        val result = requestedAmount.value * taxRate.value / 100
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.TaxFee(result)
    }

    fun taxFee(
        receivedAmount: Loan.ReceivedAmount,
        taxRate: Loan.TaxRate,
    ): Loan {
        if (receivedAmount.value < 0 || taxRate.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        val denominator = 1 + taxRate.value / 100
        if (denominator == 0.0) {
            return Loan.Error(ErrorType.DivisionByZero)
        }
        val result = receivedAmount.value - receivedAmount.value / denominator
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.TaxFee(result)
    }

    fun taxRate(
        requestedAmount: Loan.RequestedAmount,
        taxFee: Loan.TaxFee
    ): Loan {
        if (requestedAmount.value < 0 || taxFee.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        if (requestedAmount.value == 0.0) {
            return Loan.Error(ErrorType.DivisionByZero)
        }
        val result = taxFee.value / requestedAmount.value * 100
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.TaxRate(result)
    }

    fun taxRate(
        requestedAmount: Loan.RequestedAmount,
        receivedAmount: Loan.ReceivedAmount
    ): Loan {
        if (requestedAmount.value < 0 || receivedAmount.value < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        if (requestedAmount.value == 0.0) {
            return Loan.Error(ErrorType.DivisionByZero)
        }
        val result = (requestedAmount.value - receivedAmount.value) / requestedAmount.value * 100
        if (result < 0) {
            return Loan.Error(ErrorType.NegativeResult)
        }
        return Loan.TaxRate(result)
    }
}